<template>
    <div v-loading="loading" style="min-height: 400px">
        <div id="printContent" style="color: #000">
            <div :key="index" v-for="(item, index) in printList">
                <!-- <div class="print-title">供应商询价单</div> -->
                <div class="print-title-view" id="print-title-view">
                    <div v-if="isEditTitle" class="print-title">
                        <el-input type="text" style="width: 70%;" v-model="titleConfig.RValue"></el-input>
                    </div>
                    <div v-else class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : titleConfig.RValue }}</div>
                </div>
                <div class="company">单位：{{ company }}</div>
                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 16%">客户名称</div>
                        <div class="div-table-cell" style="width: 84%">{{ item.EntpCusName }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 16%">联系电话</div>
                        <div class="div-table-cell" style="width: 84%"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 16%">期限日期</div>
                        <div class="div-table-cell" style="width: 84%">{{ item.NeedTime }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell ie-width1" style="width: 16%">汽配编码</div>
                        <div class="div-table-cell ie-width2" style="width: 23%">配件名称</div>
                        <div class="div-table-cell" style="width: 20%">车型</div>
                        <div class="div-table-cell" style="width: 6%">数量</div>
                        <div class="div-table-cell" style="width: 5%">单位</div>
                        <div class="div-table-cell" style="width: 10%">报价价格</div>
                        <div class="div-table-cell" style="width: 20%">备注</div>
                    </div>
                    <div :key="index" class="div-table-row" v-for="(AP, index) in item.DetailList">
                        <div class="div-table-cell ie-width1" style="width: 16%">{{ AP.APCode }}</div>
                        <div class="div-table-cell ie-width2" style="width: 23%">{{ AP.GoodName }}</div>
                        <div class="div-table-cell" style="width: 20%">适用:{{ AP.AutoSerise }}</div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Count }}</div>
                        <div class="div-table-cell" style="width: 5%">{{ AP.Unit }}</div>
                        <div class="div-table-cell" style="width: 10%">{{ AP.MarketPrice }}</div>
                        <div class="div-table-cell" style="width: 20%">{{ AP.Remark }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell ie-width1" style="width: 16%"></div>
                        <div class="div-table-cell ie-width2" style="width: 23%"></div>
                        <div class="div-table-cell" style="width: 20%">总数量</div>
                        <div class="div-table-cell" style="width: 6%">{{ allNum }}</div>
                        <div class="div-table-cell" style="width: 5%">总价</div>
                        <div class="div-table-cell" style="width: 10%">{{ allPrice }}</div>
                        <div class="div-table-cell" style="width: 20%"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 16%">客户要求</div>
                        <div class="div-table-cell" style="width: 84%">{{ item.Remark }}</div>
                    </div>
                </div>
                <div id="foot">
                    <!--    脚注    -->
                    <div
                        class="order-remark"
                        slot="content"
                        v-if="(config == null ? false : config.Result && !isEditConfig)|| orderData.IsHaveTitleSet"
                        v-html="orderData.IsHaveTitleSet ? orderData.FootNote.replace(/\n/g, '<br/>') : config.RValue.replace(/\n/g, '<br/>')"
                    >
                    </div>
                    <div class="order-setcontent" v-if="isEditConfig">
                        <el-input type="textarea" resize="auto" rows="3" v-model="config.RValue"></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <!--   标题   -->
                <div class="re-set">
                    <el-button class="btn-primary" @click="setTitle()" v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle && !orderData.IsHaveTitleSet"
                        >编辑标题</el-button
                    >
                    <el-button class="btn-primary" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                </div>
                <!--   脚注   -->
                <div class="re-set">
                    <el-button class="btn-primary" @click="setConfig()" v-if="config == null ? false : config.Result && !isEditConfig && !orderData.IsHaveTitleSet">编辑脚注</el-button>
                    <el-button class="btn-primary" @click="submitConfig()" v-if="isEditConfig">保存脚注</el-button>
                </div>
            </div>
            <div v-if="!isEditConfig && !isEditTitle">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
export default {
    name: '',
    components: {},
    props: ['printIds'],
    data() {
        return {
            loading: false,
            allPrice: 0,
            allNum: 0,
            printList: [],
            orderData:{},
            company: this.$util.getLocalStorage('userMsg').EntpName,
            isPrint: false,
            isPreview: false,
            isDefaultSet: false,
            isEditTitle: false, //编辑标题
            isEditConfig:false,//编辑脚注
            titleConfig: {
                RValue: this.$util.getLocalStorage('userMsg').EntpName + '询价单'
            }, //标题配置
            config:null
        };
    },
    created() {
        this.getConfigByCodes();
    },
    mounted() {
        this.getBJOrder();
    },
    methods: {
        getConfigByCodes() {
            let codes = ['dyyl', 'syllqdysz','dyxjjz','dyxjbt'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'dyyl':
                                this.isPreview = result;
                                break;
                            case 'syllqdysz':
                                this.isDefaultSet = result;
                                break;
                            case 'dyxjjz':
                                this.config = data[i];
                                break;
                            case 'dyxjbt':
                                this.titleConfig = data[i];

                                if (!this.titleConfig || !this.titleConfig.RValue) this.titleConfig.RValue = this.company + '询价单';
                                break;
                        }
                    }
                }
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
                    .company {
                    padding: 20px 0;
                    }
                    .print-title {
                    text-align: center;
                    font-size: 20px;
                    font-weight: bold;
                    }
                    .dialog-footer {
                    text-align: right;
                    }
                    .ie-width1{
                        width:17.5% !important;
                    }
                    .ie-width2{
                        width:22% !important;
                    }
                    .print-table-main {
                    width: 762px;
                    margin-bottom: 20px;
                    font-size: 12px;
                    } 
                    .div-table-row {
                        display: flex;
                        margin: 0;
                        font-size: 14px;
                        border-left: 1px solid #000;
                    }
                    .div-table-cell {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        height: auto;
                        word-wrap: break-word;
                        word-break: break-all;
                        height: auto;
                        line-height: 24px;
                        padding-left: 10px;
                        border-top: 1px solid #000;
                        border-right: 1px solid #000;
                        border-bottom: 1px solid #000;
                    }
                    </style>`;

                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body>';
                if (this.printList[0].DetailList.length <= 60) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord(
                    {
                        OrderId: this.printIds[0],
                        Type: 14
                    },
                    true
                )
                .then(res => {
                    this.isPrint = true;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        getBJOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInquiryOrder/GetEntpPurInquiryPrint',
                    data: {
                        InquiryId: this.printIds[0]
                    },
                    hideLoading: true
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    this.orderData = res.data;


                    let DetailList = this.orderData.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrice += DetailList[i].Count * DetailList[i].MarketPrice;
                    }
                    this.allNum = _allNum;
                    this.allPrice = _allPrice.toFixed(2);
                    this.printList.push(res.data);
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //提交打印标题
        setTitle() {
            this.isEditTitle = true;
        },
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        },
        setConfig() {
            this.isEditConfig = true;
        },
        // 提交脚注
        submitConfig() {
            if (!this.config.RValue || !this.config.RValue.trim()) {
                this.$message.error('请输入脚注');
                return;
            }
            this.isEditConfig = false;
            this.$util.setSysConfigValue(this.config.ConfigId, this.config.RValue);
        },
    }
};
</script>
<style lang="less" scoped>
.company {
    padding: 20px 0;
}
.btn-ctn-left {
    display: flex;
}
.print-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-table-main {
    margin-bottom: 20px;
    font-size: 12px;
    .div-table-row {
        border-color: black;
    }
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        border-color: black;
        word-wrap: break-word;
        word-break: break-all;
        height: auto;
        line-height: 24px;
        padding-left: 10px;
    }
}
</style>
